export function determineActiveRoute(routeString: string) {
  return window.location.pathname.includes(`/${routeString}`);
}
